import React from 'react';
import ComparatorItemComponent from './ComparatorItemComponent';
import { Grid } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { CollapseCard } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ComparatorComponent = ({ loading, data, onSelectQuotation, onRetryQuotation, computing, offerInNegotiation }) => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseCard
        icon={ListAltIcon}
        title={t('Offer.Edit.Comparator.Title', {
          period: data && data.length ? data[0].period : ''
        })}
        defaultExpanded
        toggleOnHeaderClick
      >
        <Grid container spacing={2}>
          {!loading &&
            data &&
            data.map(quotation => {
              return (
                <ComparatorItemComponent
                  key={quotation.offerId}
                  quotation={quotation}
                  onSelectQuotation={onSelectQuotation}
                  onRetryQuotation={onRetryQuotation}
                  computing={computing}
                  offerInNegotiation={offerInNegotiation}
                />
              );
            })}
        </Grid>
      </CollapseCard>
    </>
  );
};

ComparatorComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  data: PropTypes.array,
  onSelectQuotation: PropTypes.func.isRequired,
  onRetryQuotation: PropTypes.func,
  computing: PropTypes.bool.isRequired,
  offerInNegotiation: PropTypes.bool.isRequired
};

export default ComparatorComponent;
